import { Checkbox, Col, Divider, Modal, Radio, Row } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../../components/Button/Button";
import Text from "../../../components/Text/Text";
import Input from "../../../components/Input/Input";
import { color } from "../../../resource";
import { handleNumberOnlyCopyPaste } from "../../../utility/validator";

const ModalStyled = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
    padding: 0;
  }
  .ant-modal-body {
    padding: 0;
  }
`;
export const SettingConditionQuotaEachShop = ({
  open,
  showQuota,
  showLimit,
  typeLimitQuota,
  onClose,
  onSubmit,
  countOrder,
}: {
  open: boolean;
  typeLimitQuota?: string;
  showQuota: boolean;
  showLimit: boolean;
  onClose: () => void;
  onSubmit: (quotaValue: number, limitValue: number, conditionType: string[]) => void;
  countOrder?: number;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const [conditionType, setConditionType] = useState<string[]>(() => {
    if (showQuota && !showLimit) return ["quota"];
    if (showLimit && !showQuota) return ["limit"];
    return [];
  });
  const [quotaValue, setQuotaValue] = useState("");
  const [limitValue, setLimitValue] = useState(countOrder || "");
  const [errorMessage, setErrorMessage] = useState<{
    type: string;
    errorQuota: string;
    errorLimit: string;
  }>({
    type: "",
    errorQuota: "",
    errorLimit: "",
  });

  return (
    <ModalStyled open={open} centered footer={null} onCancel={onClose}>
      <div style={{ padding: "24px 24px 0" }}>
        <Text fontSize={20} fontWeight={700}>
          เพิ่มเงื่อนไขเดียวกัน
        </Text>
      </div>
      <Divider />
      <div style={{ padding: "0 26px" }}>
        <div style={{ marginBottom: 18 }}>
          <Text fontFamily='Sarabun' fontSize={14}>
            เลือกประเภทการให้เงื่อนไขเดียวกัน <span style={{ color: color.error }}>*</span>
          </Text>
          <Checkbox.Group
            style={{ display: "flex", flexDirection: "column", rowGap: 12, marginTop: 12 }}
            value={conditionType}
            onChange={(checkedValues) => {
              setConditionType(checkedValues);
              setErrorMessage({ type: "", errorQuota: "", errorLimit: "" });
            }}
          >
            {showQuota && (
              <Checkbox value='quota'>
                <Text fontFamily='Sarabun' fontSize={14}>
                  โควตา
                </Text>
              </Checkbox>
            )}
            {showLimit && (
              <Checkbox value='limit' disabled={typeLimitQuota?.includes("allShop")}>
                <Text fontFamily='Sarabun' fontSize={14}>
                  จำกัดคำสั่งซื้อ/วัน
                </Text>
              </Checkbox>
            )}
          </Checkbox.Group>
          {errorMessage.type ? (
            <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
              โปรดเลือกประเภทเงื่อนไข
            </Text>
          ) : null}
        </div>

        {conditionType?.includes("quota") && (
          <div style={{ marginBottom: 24 }}>
            <Text fontSize={14} fontFamily='Sarabun'>
              จำนวนโควตา
              <span style={{ color: color.error }}>*</span>
            </Text>
            <Input
              placeholder='ระบุจำนวนโควตา'
              suffix={
                <Text fontSize={14} fontFamily='Sarabun'>
                  {userCompany?.companyType?.includes("Chemical") ? "ลัง/กระสอบ" : "ตัน"}
                </Text>
              }
              onChange={(e) => setQuotaValue(e.target.value)}
              onKeyDown={handleNumberOnlyCopyPaste}
              style={{ marginTop: 8 }}
            />
            {errorMessage?.errorQuota && (
              <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
                {errorMessage?.errorQuota}
              </Text>
            )}
          </div>
        )}

        {conditionType?.includes("limit") && (
          <div style={{ marginBottom: 12 }}>
            <Text fontSize={14} fontFamily='Sarabun'>
              จำกัดคำสั่งซื้อ / วัน
              <span style={{ color: color.error }}>*</span>
            </Text>
            <Input
              value={limitValue}
              placeholder={"ระบุจำนวนคำสั่งซื้อ"}
              suffix={
                <Text fontSize={14} fontFamily='Sarabun'>
                  ครั้ง / วัน
                </Text>
              }
              onChange={(e) => setLimitValue(e.target.value)}
              onKeyDown={handleNumberOnlyCopyPaste}
              style={{ marginTop: 8, color: color.BK }}
              disabled={typeLimitQuota?.includes("allShop")}
            />
            {errorMessage.errorLimit && (
              <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
                {errorMessage?.errorLimit}
              </Text>
            )}
          </div>
        )}
      </div>
      <Divider />
      <Row justify='end' gutter={8} style={{ padding: "0 22px 22px" }}>
        <Col>
          <Button typeButton='primary-light' title='ยกเลิก' onClick={onClose} />
        </Col>
        <Col>
          <Button
            typeButton='primary'
            title='ยืนยัน'
            onClick={() => {
              if (
                (conditionType?.includes("quota") && !quotaValue) ||
                (conditionType?.includes("limit") && !limitValue) ||
                conditionType.length === 0
              ) {
                setErrorMessage({
                  type: conditionType.length === 0 ? "โปรดเลือกประเภทเงื่อนไข" : "",
                  errorQuota: !quotaValue ? "ระบุจำนวนโควตา" : "",
                  errorLimit: !limitValue ? "ระบุจำนวนจำกัดคำสั่งซื้อ/วัน" : "",
                });
                return;
              } else {
                onSubmit(Number(quotaValue), Number(limitValue), conditionType);
              }
            }}
          />
        </Col>
      </Row>
    </ModalStyled>
  );
};

export const SettingConditionQuotaEachShopProduct = ({
  open,
  onClose,
  onSubmit,
  isSpecialPrice,
  isLimitOrder,
}: {
  open: boolean;
  onClose: () => void;
  onSubmit: (quotaValue: number, limitValue: number, conditionType: string[]) => void;
  isSpecialPrice?: boolean;
  isLimitOrder?: boolean;
}) => {
  const userCompany = JSON.parse(localStorage.getItem("company")!);
  const [conditionType, setConditionType] = useState<string[]>(
    isSpecialPrice && !isLimitOrder
      ? ["specialPrice"]
      : isLimitOrder && !isSpecialPrice
        ? ["limitOrder"]
        : [],
  );
  const [specialPriceValue, setSpecialPriceValue] = useState("");
  const [limitOrderValue, setLimitOrderValue] = useState("");
  const [errorMessage, setErrorMessage] = useState<{
    type: string;
    errorPrice: string;
    errorLimit: string;
  }>({
    type: "",
    errorPrice: "",
    errorLimit: "",
  });

  return (
    <ModalStyled open={open} centered footer={null} onCancel={onClose}>
      <div style={{ padding: "24px 24px 0" }}>
        <Text fontSize={20} fontWeight={700}>
          เพิ่มเงื่อนไขเดียวกัน
        </Text>
      </div>
      <Divider />
      <div style={{ padding: "0 26px" }}>
        <div style={{ marginBottom: 18 }}>
          <Text fontFamily='Sarabun' fontSize={14}>
            เลือกประเภทการให้เงื่อนไขเดียวกัน <span style={{ color: color.error }}>*</span>
          </Text>
          <Checkbox.Group
            style={{ display: "flex", flexDirection: "column", rowGap: 12, marginTop: 12 }}
            value={conditionType}
            onChange={(checkedValues) => {
              setConditionType(checkedValues);
              setErrorMessage({ type: "", errorPrice: "", errorLimit: "" });
            }}
          >
            {isSpecialPrice && (
              <Checkbox value='specialPrice'>
                <Text fontFamily='Sarabun' fontSize={14}>
                  ราคาพิเศษที่ลด
                </Text>
              </Checkbox>
            )}
            {isLimitOrder && (
              <Checkbox value='limitOrder'>
                <Text fontFamily='Sarabun' fontSize={14}>
                  จำกัดจำนวนซื้อ/คำสั่งซื้อ
                </Text>
              </Checkbox>
            )}
            {errorMessage?.type && (
              <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
                {errorMessage?.type}
              </Text>
            )}
          </Checkbox.Group>
        </div>

        {conditionType?.includes("specialPrice") && (
          <div style={{ marginBottom: 24 }}>
            <Text fontSize={14} fontFamily='Sarabun'>
              ราคาพิเศษที่ลด
              <span style={{ color: color.error }}>*</span>
            </Text>
            <Input
              placeholder='ระบุราคาพิเศษที่ลด'
              suffix={
                <Text fontSize={14} fontFamily='Sarabun'>
                  บาท
                </Text>
              }
              onChange={(e) => setSpecialPriceValue(e.target.value)}
              onKeyDown={handleNumberOnlyCopyPaste}
              style={{ marginTop: 8 }}
            />
            {errorMessage?.errorPrice && (
              <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
                {errorMessage?.errorPrice}
              </Text>
            )}
          </div>
        )}

        {conditionType?.includes("limitOrder") && (
          <div style={{ marginBottom: 12 }}>
            <Text fontSize={14} fontFamily='Sarabun'>
              จำกัดจำนวนซื้อ/คำสั่งซื้อ
              <span style={{ color: color.error }}>*</span>
            </Text>
            <Input
              placeholder={"ระบุจำนวนคำสั่งซื้อ"}
              suffix={
                <Text fontSize={14} fontFamily='Sarabun'>
                  {userCompany?.companyType?.includes("Chemical") ? "ลัง/กระสอบ" : "ตัน"}
                </Text>
              }
              onChange={(e) => setLimitOrderValue(e.target.value)}
              onKeyDown={handleNumberOnlyCopyPaste}
              style={{ marginTop: 8, color: color.BK }}
            />
            {errorMessage?.errorLimit && (
              <Text fontSize={12} style={{ color: color.error, marginTop: 6 }}>
                {errorMessage?.errorLimit}
              </Text>
            )}
          </div>
        )}
      </div>
      <Divider />
      <Row justify='end' gutter={8} style={{ padding: "0 22px 22px" }}>
        <Col>
          <Button typeButton='primary-light' title='ยกเลิก' onClick={onClose} />
        </Col>
        <Col>
          <Button
            typeButton='primary'
            title='ยืนยัน'
            onClick={() => {
              if (
                (conditionType?.includes("specialPrice") && !specialPriceValue) ||
                (conditionType?.includes("limitOrder") && !limitOrderValue) ||
                conditionType?.length === 0
              ) {
                setErrorMessage({
                  type: conditionType?.length === 0 ? "โปรดเลือกประเภทเงื่อนไข" : "",
                  errorPrice: !specialPriceValue ? "ระบุราคาพิเศษ" : "",
                  errorLimit: !limitOrderValue ? "ระบุจำนวนจำกัดคำสั่งซื้อ/วัน" : "",
                });
                return;
              } else {
                onSubmit(Number(specialPriceValue), Number(limitOrderValue), conditionType);
              }
            }}
          />
        </Col>
      </Row>
    </ModalStyled>
  );
};
